var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "earnings-card" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-card-title", { staticClass: "mb-1" }, [
                _vm._v(" Customers "),
              ]),
              _c("div", { staticClass: "font-medium-2" }, [
                _vm._v("This Month"),
              ]),
              _c("h5", { staticClass: "mb-1" }, [
                _vm._v(_vm._s(_vm.customerCountForCurrentMonth)),
              ]),
              _c("b-card-text", { staticClass: "text-muted font-small-2" }, [
                _c("span", [_vm._v(" Number of customers this month.")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }